import { useTranslation } from "react-i18next";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import "../styles/page-not-found.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const PageNotFoundComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="background">
      <Container className="vh-100">
        <Row className="center">
          <Col className="text-center" xl={6} lg={6} md={12}>
            <Image
              src="/assets/images/outer-space.webp"
              alt={t('pageNotFound.imageAlt')}
              className="img-fluid page-not-found-image"
            />
          </Col>

          <Col className="text-section" xl={6} lg={6} md={12}>
            <h1 className="page-not-found-title">{t('pageNotFound.title')}</h1>
            <p className="page-not-found-title-text">
              {t('pageNotFound.description')}
              {/* <br />
              Don't worry, you can still browse my website by clicking the
              button below. */}
            </p>

            <Button variant="outline-info" href="/">
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="button-icon-padding-previous"
              />
              {t('backToHomepage')}
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PageNotFoundComponent;
